import { ColumnDef } from '@tanstack/react-table'
import { GetOperatorMemberListTableData } from '@/modules/manage-member/type'
import DeleteMemberModal from './CellAction/components/DeleteMember'
import { IsActiveMember } from './CellAction/components/IsActiveMember'
import { EditMember } from './CellAction/components/EditMember'
import { Manage2FA } from './CellAction/components/Manage2FA'
import { groupNameMapper } from '@/modules/manage-member/mappers'

export const columns: ColumnDef<GetOperatorMemberListTableData>[] = [
	{
		accessorKey: 'username',
		header: 'ชื่อผู้ดูแลระบบ',
	},
	{
		accessorKey: 'userGroup.name',
		header: 'ประเภทผู้ดูแลระบบ',
		cell: ({ row }) => (
			<>
				{groupNameMapper[row.original.userGroup.name] ||
					row.original.userGroup.name}
			</>
		),
	},
	{
		accessorKey: 'isActive',
		header: 'สถานะ',
		cell: ({ row }) => <IsActiveMember row={row.original} />,
	},
	{
		id: '2fa',
		header: '2FA',
		cell: ({ row }) => <Manage2FA row={row.original} />,
	},
	{
		id: 'action',
		header: 'แก้ไข',
		cell: ({ row }) => <EditMember row={row.original} />,
	},
	{
		id: 'delete',
		header: 'ลบ',
		cell: ({ row }) => <DeleteMemberModal id={row.original.id} />,
	},
]

export const writeAccessorKeys = ['action', 'delete', 'isActive', '2fa']
